import type { BookingSessionResponse, SubmitInsuranceRequest } from '@massilia/queries'
import type { UseMutateAsyncFunction } from '@tanstack/react-query'

import { AssurancesForm } from './assurances-form'
import { AssurancesLoadingSkeleton } from './loading-skeleton'

interface AssurancesPageProps {
  sessionId: string
  isLoading: boolean
  isLoadingEstimate: boolean
  isSubmitting: boolean
  session?: BookingSessionResponse
  submitInsurance: UseMutateAsyncFunction<
    BookingSessionResponse,
    Error,
    SubmitInsuranceRequest,
    unknown
  >
}

export function AssurancesPage({
  sessionId,
  isLoading,
  isLoadingEstimate,
  isSubmitting,
  session,
  submitInsurance,
}: AssurancesPageProps) {
  if (isLoading && !session) {
    return <AssurancesLoadingSkeleton />
  }

  return (
    <AssurancesForm
      isLoadingEstimate={isLoadingEstimate}
      isSubmitting={isSubmitting}
      session={session}
      sessionId={sessionId}
      submitInsurance={submitInsurance}
    />
  )
}
